import { render, staticRenderFns } from "./M2MX.vue?vue&type=template&id=bc01228a&scoped=true&"
import script from "./M2MX.vue?vue&type=script&lang=js&"
export * from "./M2MX.vue?vue&type=script&lang=js&"
import style0 from "./M2MX.vue?vue&type=style&index=0&id=bc01228a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc01228a",
  null
  
)

export default component.exports